import * as React from 'react'
import { FieldProps } from 'formik'
import { Block } from '$views/components/Layout/Block'
import { Select } from '$views/components/Select/Select'
import { draft } from '$utils/services/formDraftService'
import { ErrorText } from '$views/components/Input'
import { broadcastFormDraftName } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'

interface Props {
  label: string
  list: {
    label: string
    value: string
  }[]
  onChange: (event) => void
  inline?: boolean
  onBlur: (event) => void
}

export const HoursPerWeekField: React.SFC<Props & FieldProps<any>> = ({
  onChange,
  list,
  field,
  form,
  onBlur,
  ...props
}) => {
  const changeFieldValues = (event, fieldName) => {
    form.setValues({ ...form.values, [fieldName]: event.value })
    draft.set(broadcastFormDraftName, { [fieldName]: event.value })
  }

  const selectDefault = (fieldName: string) => {
    if (form.values[fieldName]) {
      return form.values[fieldName]
    }
    return ''
  }

  const hasError = form.submitCount > 0 && form.errors.hoursPerWeek

  return (
    <Block marginTop="mini" marginBottom="mini">
      <Select
        onChange={event => changeFieldValues(event, field.name)}
        placeholder={'¿Cuántas horas a la semana?'}
        defaultOption={selectDefault(field.name)}
        name={field.name}
        options={list}
      />
      {hasError && (
        <ErrorText as="p" caption error>
          {form.errors.hoursPerWeek}
        </ErrorText>
      )}
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/components/HoursPerWeek/components/HoursPerWeekField.tsx